import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../api';

/**
 * This interceptor adds the headers to all request.
 *
 * @export
 * @class HttpTokenInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private readonly tokenService: TokenService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.tokenService) {
      return next.handle(req);
    }

    const headersConfig = req.headers;

    if (this.tokenService.hasToken()) {
      headersConfig.set('Authorization', `Bearer ${this.tokenService.getToken()}`);
    }

    const request = req.clone({ headers: headersConfig });
    return next.handle(request);
  }
}
